<template>

  <div class="login-wrapper register">
    <container>

      <div class="col-xl-8 offset-xl-2 pad0">
        <div class="login-gen">
          <div class="login-box register-box col-xl-6">
            <row class="tabs">
              <div class="tabs__item"
                   v-for="tab in tabs" :key="tab.id"
                   :class="{ 'active-tab' : tab.active }"
                   @click="tabShow(tab.id)">
                <img class="tabs__item-img" :src="tab.icon" alt="">
                <span class="tabs__item-link">{{ tab.title }}</span>
              </div>
            </row>

            <div class="register-box_input">
              <v-input placeholder="Adınız" v-model="first_name"/>
              <label for="first_name" v-if="emptyFirstName" class="myValidationText">Bu kısım boş geçilemez!</label>
              <v-input placeholder="Soyadınız" v-model="last_name"/>
              <label for="last_name" v-if="emptyLastName" class="myValidationText">Bu kısım boş geçilemez!</label>
              <!--<v-input placeholder="Üniversite Adı"/>-->
              <v-select :options="universities" placeholder="Üniversite Seç" @onselect="selectUniversity"/>
              <label for="university" v-if="emptyUniversity" class="myValidationText">Bu kısım boş geçilemez!</label>
              <v-select :options="faculties" placeholder="Fakülte Seç"  @onselect="selectFaculty"/>
              <label for="faculty" v-if="emptyFaculty" class="myValidationText">Bu kısım boş geçilemez!</label>
              <!--<v-input placeholder="Fakülte Adı"/>-->
              <VueInputRestricted placeholder="Telefon No" v-model="phone"/>
              <label for="phone" v-if="emptyPhone" class="myValidationText">Bu kısım boş geçilemez!</label>
              <label for="phone" v-if="falsePhone" class="myValidationText">Telefon numarası 0 ile başlamalıdır!</label>
              <label for="phone" v-if="shortPhone" class="myValidationText">Telefon numarası 11 hane olmalıdır!</label>
            </div>
          </div>
          <div class="register-box__info col-xl-6">
            <div class="or blue">
              <p class="or__title-blue">GİRİŞ BİLGİLERİ</p>
            </div>
            <v-input placeholder="E-Posta adresi" v-model="email" :autocomplete="false"/>
            <label for="password" v-if="falseEmail" class="myValidationText">Geçersiz e-posta formatı!</label>
            <label for="password" v-if="emptyEmail" class="myValidationText">Bu kısım boş geçilemez!</label>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <v-input placeholder="Şifre" v-model="password" type="password" />
                <label for="password" v-if="emptyPassword" class="myValidationText">Bu kısım boş geçilemez!</label>
                <label for="phone" v-if="shortPassword" class="myValidationText">Şifre en az 6 karakter olmalıdır!</label>
                
              </div>

              <div class="col-xs-12 col-md-6">
                <v-input placeholder="Şifre Tekrar" v-model="password_check" type="password"/>
                <label for="password" v-if="emptyPasswordCheck" class="myValidationText">Bu kısım boş geçilemez!</label>
                <label for="password" v-if="passwordCheckEqual" class="myValidationText">Her iki şifre aynı olmalıdır!</label>
                <label for="phone" v-if="shortPasswordCheck" class="myValidationText">Şifre en az 6 karakter olmalıdır!</label>
                
              </div>
            </div>

            <div class="check-wrapper smart-map">
              <div class="check-wrapper__item">
                <label class="container2" style="width: 100%;">
                  <div class="check"><input type="checkbox" style="width: auto;" v-model="checkedForm"><span class="checkmark"></span>
                  <a href="/kullanici-sozlesmesi" class="" itemtype="https://schema.org/Thing" itemprop="item"
                         target="_blank">
                  <span
                    class="name"> Üyelik Sözleşmesi'ni okudum kabul ediyorum. </span></a>
                  </div>
                </label>
                 <label for="password" v-if="emptyCheckForm" class="myValidationText">Üyelik Sözleşmesi'ni kabul etmeniz gerekiyor!</label>
              </div>

              <div class="check-wrapper__item">
                <label class="container2" style="width: 100%;">
                  <div class="check"><input type="checkbox" style="    width: auto;"><span
                    class="checkmark"></span><span class="name"> Tüm duyuru ve kampanyalardan ticari e-ileti yoluyla haberdar olmak istiyorum. </span>
                  </div>
                </label>
              </div>

            </div>

            <v-button
              class="green fw shadow-none login-box__submit"
              title="HEMEN ÜYE OL"
              @click.native="submitForm"
            />

            <div class="or">
              <p class="or__title">VEYA</p>
            </div>
            <v-button
              class="gray fw shadow-none login-box__submit"
              title="GİRİŞ YAP"
              @click.native="gitLogin"
            />

<!--             <div class="login-box__bottom">
              <p class="login-box__bottom-text">Zaten bir yurtlarburada.com hesabınız var mı ?</p>
              <router-link to="/kayit-ol" class="button button--more color-light-green"><span
                class="button__wrp"><span class="button__txt">
    ŞİMDİ GİRİŞ YAP
  </span><span class="button__icon"><svg class="icon"><use
                xlink:href="/icon/icons.svg#icon-arrow-long-right"></use></svg></span></span></router-link>

              <div class="login-box__dorm">
                <router-link to="/yurt-kayit"
                             class="button button--more color-light-green"><span class="button__wrp">
                <span class="button__txt">
      YURT KAYIT
    </span><span class="button__icon"><svg class="icon"><use
                  xlink:href="/icon/icons.svg#icon-arrow-long-right"></use></svg></span></span></router-link>
              </div>
            </div> -->
          </div>

          <div class="register-info">
          <div class="about-info__item item-register">
              <div class="about-info__item--left item-register--left">
                <div class="about-info__item_img item-register_img"><img src="/img/dom.080e8c0e.svg" alt=""></div>
              </div>

              <div class="about-info__item--right item-register--right">
                <div class="about-info__number"><strong>3.700+</strong>
                  <p>Kayıtlı Yurt</p></div>
                <div class="about-info__item_text"><p>Şehirlerdeki en popüler yurtları sizin için araştırır ziyaret eder ve yayınlarız!
                </p></div>
              </div>
            </div>

            
            <div class="about-info__item item-register">
              <div class="about-info__item--left item-register--left">
                <div class="about-info__item_img item-register_img"><img src="/img/visitor.9441c916.svg" alt=""></div>
              </div>

               <div class="about-info__item--right item-register--right">
                <div class="about-info__number"><strong>2 Milyon+</strong>
                  <p>Yıllık Ziyaretçi</p></div>
                <div class="about-info__item_text"><p>Yurt fiyatlarını öğrenmek için onlarca yurdu aramanız gerekmez!
                </p></div>
              </div>
            </div>
            
                   <div class="about-info__item item-register">
              <div class="about-info__item--left item-register--left">
               <div class="about-info__item_img item-register_img"><img src="/img/view.b6193a4c.svg" alt=""></div>
              </div>

               <div class="about-info__item--right item-register--right">
                <div class="about-info__number"><strong>4 Milyon+</strong>
                  <p>Yıllık Görüntülenme</p></div>
                <div class="about-info__item_text"><p>Türkiye'nin ilk yurt tanıtım rehberi olarak 10 yılı aşkın süredir sektördeyiz!</p>
              </div>
            </div>
            </div>
            

          </div>
        </div>
      </div>

    </container>
  </div>
</template>

<script>
import axios from 'axios'
import VueInputRestricted from '@/components/VueInputRestricted'

import * as userApi from '@/api/user'
export default {
  name: 'Register',
  components: {
   VueInputRestricted
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Üye Ol',
      link: [
        { rel: 'canonical' },
        { href: window.location.origin + '/uye-ol' }
      ]
    }
  },   
  data () {
    return {
      tabs: [
        {
          id: 0,
          title: 'ÜYE OL',
          icon: require('@/assets/img/register-student.svg'),
          active: true
        }
      ],
      checkedForm: false,
      emptyCheckForm: false,
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      emptyFirstName: false,
      emptyLastName: false,      
      emptyPhone: false,
      emptyEmail: false,
      emptyEmail2: false,
      emptyUniversity: false,
      emptyFaculty: false,
      emptyPassword: false,
      emptyPasswordCheck: false,
      passwordCheckEqual: false,
      shortPassword: false,
      shortPasswordCheck: false,
      universities: null,
      faculties: null,
      first_name: '',
      last_name: '',
      university_id: '',
      faculty_id: '',
      phone: '',
      email: '',
      password: '',
      password_check: ''
    }
  },
  methods: {
    gitLogin () {
      this.$router.push('/uye-girisi')
    },
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
},     
    tabShow (id) {
      this.tabs.forEach((item) => {
        item.active = false
      })
      this.tabs[ id ].active = true
    },
    getUniversities () {
      let self = this
      axios.get('/selected/universities')
        .then(response => {
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectUniversity (opt) {
      this.university_id = opt.id
      let self = this
      axios.get(`/selected/faculties/${opt.id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectFaculty (opt) {
      this.faculty_id = opt.id
    },
    submitForm () {
      this.emptyCheckForm = false
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.shortPassword = false
      this.shortPasswordCheck = false
      this.emptyFirstName = false
      this.emptyLastName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyFaculty = false
      this.emptyPassword = false
      this.emptyPasswordCheck = false
      this.passwordCheckEqual = false

      if(!this.checkedForm) {
      this.emptyCheckForm = true
      }

      const verifiedMail = this.validateEmail(this.email)

      if(!this.email) {
        this.emptyEmail = true
      } else if(this.email &&!verifiedMail) {
        this.falseEmail = true
      }
      if(!this.first_name) {
        this.emptyFirstName = true
      }
      if(!this.last_name) {
        this.emptyLastName = true
      }      
            if(!this.name) {
        this.emptyName = true
      }
      if(!this.phone) {
        this.emptyPhone = true
      }
      if(this.phone && !this.phone.startsWith("0")) {
        this.falsePhone = true
      }      

      if(this.phone && !this.falsePhone && this.phone.length != 11) {
        this.shortPhone = true
      }
      if(this.password && this.password.length < 6) {
        this.shortPassword = true
      }
      if(this.password_check && this.password_check.length  < 6) {
        this.shortPasswordCheck = true
      }      
      if(!this.password) {
        this.emptyPassword = true
      }
      if(!this.password_check) {
        this.emptyPasswordCheck = true
      }
      if(this.password && this.password_check && !this.shortPassword && !this.shortPasswordCheck && this.password != this.password_check) {
        this.passwordCheckEqual = true
      }    
      if(!this.university_id) {
        this.emptyUniversity = true
      }
      if(!this.faculty_id) {
        this.emptyFaculty = true
      }

if (!this.emptyFirstName && !this.emptyLastName && !this.emptyEmail && !this.falseEmail && !this.emptyPassword && verifiedMail && !this.emptyPhone && !this.falsePhone && !this.shortPhone && !this.emptyUniversity && !this.emptyFaculty && !this.emptyPassword && !this.emptyPasswordCheck && !this.passwordCheckEqual && !this.shortPassword && !this.shortPasswordCheck && !this.emptyCheckForm) {
      userApi.register(this.first_name, this.last_name, this.university_id, this.faculty_id, this.phone, this.email, this.password)
        .then((response) => {
          if (response.status === 201) {
            this.$router.push({ name: 'Login' })
          }
        })
    }
    }
  },
  created () {
    this.getUniversities()
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/register";

  .wrapper {
    padding-bottom: 275px;
  }

  .myValidationText {
    font-size: 13px;
    color: #dc3545;
  }
</style>
